<template>
 <v-expansion-panel class="grey lighten-4 mb-2">
  <v-expansion-panel-header>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title class="font-weight-bold">{{
        dependente.nome
      }}</v-list-item-title>
      <v-list-item-subtitle class="mt-1">
        <v-chip  small class="success subtitle-2">{{
          dependente.grau
        }}</v-chip>
      </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
      <v-card flat class="grey lighten-4">
        <v-card-text class="pt-0">
           <p>
          Sexo: <b>{{ dependente.sexo }}</b>
        </p>
        <p>
          Data de nascimento: <b>{{ dependente.nascimento }}</b>
        </p>        
        <p>
          Estado de saúde: <b>{{ dependente.estadosaude }}</b>
        </p>
        <p>
          Dependente Plano de Saúde: <b>{{ dependente.planodesaude }}</b>
        </p>
        
        <p class="mt-2 mb-3">
          Incidência: <icone-ajuda-incidencia/>
          <ul>
            <li>Imposto de Renda: <span><b>{{ dependente.incidenciair }}</b></span></li>
            <li>Salário Família: <span :style="getCorIncidenciaSf()"><b>{{ dependente.incidenciasf }}</b></span></li>
          </ul>
        </p>
        
        <p>
          Dec. Freq. Escolar: <b>{{ dependente.comprovfrequencia }}</b>
        </p>  
         <p>
          Data Atualização: <b>{{ dependente.dataatualizacao }}</b>
        </p>  
         <p>
          Status: <b  :style="estiloStatus(dependente)">{{ dependente.descstatus }}</b>
        </p>  

        <v-alert border="left" type="warning" text v-if="dependente.status == 2 && dependente.observacao != ''" class="mt-3 mb-0"  >
          <i class="subtitle-1">{{ dependente.observacao }}</i>          
        </v-alert>
        </v-card-text>
         <v-card-actions>
         <v-container fluid>
           <v-row dense>
             <v-col xl="auto" lg="auto" md="auto" cols="12" align-self="start"><editar-dependente :dependente="dependente"/></v-col>
             <v-col xl="auto" lg="auto" md="auto" cols="12"><cancelar-dependente v-if="dependente.status < 3" :dependente="dependente"/></v-col>
           </v-row>
         </v-container>          
      </v-card-actions>
      </v-card>
  </v-expansion-panel-content>
 </v-expansion-panel>
 
</template>

<script>
import CancelarDependente from "./CancelarDependente.vue";
import EditarDependente from "./EditarDependente.vue";
import IconeAjudaIncidencia from "./IconeAjudaIncidencia.vue";

export default {
  components: { IconeAjudaIncidencia, CancelarDependente, EditarDependente },
  props: {
    dependente: Object,
  },
  methods: {
    estiloStatus(value) {
      return `color: rgb(${value.cor[0]},${value.cor[1]},${value.cor[2]},1)`;
    },
    getCorIncidenciaSf() {
      return `color: rgb(${this.dependente.corincidenciasf[0]},${this.dependente.corincidenciasf[1]},${this.dependente.corincidenciasf[2]})`;
    },
  },
};
</script>

<style scoped>
p {
  margin-bottom: 3px !important;
}
</style>
